import styled from 'styled-components'
import Button from 'components/Button/Button'

export const SSOToolButton = styled(Button)`
  margin: 5px;
  color: '#002855';
`
export const SSOToolColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`
export const SSOToolLayoutSection = styled.div`
  display: flex;
`
export const SSOToolLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/containers/css-admin/sso-tool/styles.js